// extracted by mini-css-extract-plugin
module.exports = {"input":"element_input__3FY9r","dropArea":"element_dropArea__2IXGl"};